import styled from "@emotion/styled";
import {
  Grid,
  Table,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import KeyValueBoxProps from "./KeyValueBoxProps.type";
import colors from "../../../helpers/colors";
import { defaultFonts } from "../../../helpers/fonts";
import DOMHelper from "src/helpers/DOMHelper";

const BoxContainer = styled(Box)({
  width: "100%",
  fontFamily: defaultFonts,
  marginTop: "30px",
  borderRadius: "12px",
});

const Header = styled(TableHead)(
  (props: { color: string; bgcolor: string; borderColor: string }) => ({
    backgroundColor: props.bgcolor ? props.bgcolor : colors.off.background,
    color: props.color ? props.color : colors.off.text,
    fontWeight: "bolder",
    fontSize: "1.2rem",
    padding: "6px !important",
    borderTopRightRadius: "6px",
    borderTopLeftRadius: "6px",
    "& th:first-child": {
      borderTopRightRadius: "6px",
      borderTopLeftRadius: "6px",
    },
  })
);

const TitleCell = styled(TableCell)({
  fontSize: "22px",
  fontWeight: 800,
});

const KeyCell = styled(TableCell)({
  fontSize: "16px",
  fontWeight: 700,
  width: "30%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const ValueCell = styled(TableCell)({
  maxWidth: "300px",
  width: "70%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const ValueContainer = styled.div({
  maxWidth: "100%",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

const KeyValueBox = (props: KeyValueBoxProps): JSX.Element => {
  const { title, headerColor, headerbgcolor, values, borderColor } = props;
  return (
    <BoxContainer>
      <Table
        style={{
          borderRadius: "6px",
          width: props.width ? props.width : "100%",
        }}
      >
        <Header
          color={headerColor}
          bgcolor={headerbgcolor}
          borderColor={borderColor ? borderColor : colors.off.background}
        >
          <TableRow>
            <TitleCell colSpan={2}>{title}</TitleCell>
          </TableRow>
        </Header>
        {values.map((value, i) => {
          const id = `value-${value.key}-${i}`;

          return (
            <TableRow key={`keyvalue-row-${i}`}>
              <KeyCell>
                <div>{value.key}</div>
              </KeyCell>
              <ValueCell>
                {value.isComponent ? (
                  value.component
                ) : (
                  <ValueContainer id={id}>
                    <Tooltip
                      title={
                        DOMHelper.componentHasOverflowX(id) ? value.value : ""
                      }
                    >
                      <>{value.value}</>
                    </Tooltip>
                  </ValueContainer>
                )}
              </ValueCell>
            </TableRow>
          );
        })}
      </Table>
    </BoxContainer>
  );
};

export default KeyValueBox;
